if (!customElements.get('cobd-mercedes-bundle')) {
  customElements.define('cobd-mercedes-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-native-bundle-form]');
      this.button = this.querySelector('button[type="submit"]');
      this.error = this.querySelector('[data-bundle-error]');
      this.selects = [...this.querySelectorAll('[data-bundle-cable]')];
      this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.form.addEventListener('change', () => this.updatePrice());
      this.form.addEventListener('submit', event => this.addBundle(event));
      this.updatePrice();
    }
    money(cents) { return this.formatter.format(cents / 100); }
    selection() { return this.selects.map(select => select.selectedOptions[0]); }
    updatePrice() {
      const selected = this.selection();
      const available = selected.length === 2 && selected.every(option => option && option.dataset.available === 'true');
      this.button.disabled = !available;
      this.button.textContent = available ? this.dataset.ready : this.dataset.unavailable;
      const prices = selected.map(option => Number(option?.dataset.price || 0));
      const total = prices[0] + prices[1];
      const saving = Math.round(prices[1] * 0.3);
      this.querySelector('[data-bundle-original]').textContent = this.money(total);
      this.querySelector('[data-bundle-total]').textContent = this.money(total - saving);
      this.querySelector('[data-bundle-saving]').textContent = this.dataset.saveTemplate.replace('[amount]', this.money(saving));
      this.querySelector('[data-bundle-percent]').textContent = this.dataset.percentTemplate.replace('[percent]', total ? Math.round(100 * saving / total) : 0);
      const inclusive = this.querySelector('[data-bundle-inclusive]');
      if (inclusive) inclusive.textContent = this.money(Math.round((total - saving) * (1 + Number(this.dataset.vat) / 100)));
    }
    async addBundle(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.form.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({items: this.selection().map(option => ({id: Number(option.value), quantity: 1}))})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.updatePrice();
      }
    }
  });
}
